import siFetch from "api/fetch";

const stats = (init = null) => siFetch("/api/v1/campaign/stats", init);

export default stats;
